var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-5 pt-0"},[_c('OrganisationList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }